'use client';

import { useEffect } from 'react';

import { addExtraOptionsToFechApi } from '@crehana/next';

export const InterceptFetchRequestsAndAddCustomHeaders = () => {
  useEffect(() => {
    addExtraOptionsToFechApi();
  }, []);

  return null;
};
